<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Zaloguj się</span>
    <span subtitle>Zaloguj się, aby skorzystać z portalu</span>
  </app-form-title-with-subtitle>
</div>

<div class="mb-8">
  <app-alerts />

  <app-sign-in-form (submitClickEvent)="handleSubmitClickEvent($event)">
    <ng-content select="[remind-password-slot]" />
  </app-sign-in-form>
</div>

@if (shouldShowSocials()) {
  <div>
    <h2 class="text-xl font-medium">lub zaloguj się za pomocą:</h2>

    <div class="flex gap-3">
      <button (click)="handleSignInByFacebookClick()">
        <app-social-icon [type]="SocialIconType.Facebook" />
      </button>

      <button (click)="handleSignInByGoogleClick()">
        <app-social-icon [type]="SocialIconType.Google" />
      </button>
    </div>
  </div>
}
